import { Form, Space, Tooltip } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Dispatch, SetStateAction, memo } from 'react';

import { EditIcon } from 'assets/svg';
import TableComponent from 'components/Table/TableComponent';
import useQueryParam from 'hooks/useQueryPrams';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import Content from 'layouts/Content';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import { ITableUserPermission } from './PermissionPage';

interface IProps {
  data: ITableUserPermission;
  setEditIndex: (id: number) => void;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  loading?: boolean;
}
const TablePermission = ({
  data,
  setEditIndex,
  setOpenModal,
  loading,
}: IProps) => {
  const [form] = useForm();

  const queryParam = useQueryParam(),
    page = parseInt(queryParam.get('page') + '') || 1,
    page_size = parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const columns: ColumnsTypeCustom = [
    {
      width: 50,
      title: 'STT',
      render: (_, __, index) => index + 1 + page_size * (page - 1),
    },
    {
      width: 70,
      title: 'Chi nhánh',
      dataIndex: 'plantCode',
    },
    {
      width: 100,
      dataIndex: 'employeeId',
      title: 'Mã nhân viên',
    },
    {
      width: 100,
      dataIndex: 'fullName',
      title: 'Tên nhân viên',
    },
    {
      width: 100,
      title: 'Email',
      dataIndex: 'email',
    },
    {
      width: 150,
      title: 'Job Title',
      dataIndex: ['tjobtitle', 'jobName'],
    },
    {
      width: 150,
      title: 'Job Title Code',
      dataIndex: 'jobTitleCode',
    },
    {
      width: 150,
      title: 'Quyền',
      dataIndex: ['trole', 'name'],
      render: (value: any, record: any) => {
        // if (!value && record?.tjobtitle?.trole) {
        //   return record.tjobtitle.trole.name;
        // }
        return value;
      },
    },
    {
      width: 80,
      fixed: 'right',
      align: 'center',
      title: 'Thao tác',
      render: (_, __, index) => {
        const handleClickEdit = () => {
          setEditIndex(index);
          setOpenModal(true);
        };

        return (
          <Space size={'middle'} className="text-lg ">
            <Tooltip placement="top" title={'Chỉnh sửa'}>
              <EditIcon className="cursor-pointer" onClick={handleClickEdit} />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  return (
    <Content>
      <Form form={form}>
        <TableComponent
          rowKey={(record: any) => record.id}
          columns={columns}
          dataSource={data.items}
          pagination={{
            current: data.pageInfo?.currentPage,
            pageSize: data.pageInfo?.itemsPerPage,
            total: data.pageInfo?.totalItems,
            onChange: HocChangePagination(),
          }}
          loading={loading}
        />
      </Form>
    </Content>
  );
};

export default memo(TablePermission);
